/**
 * this is ment to turn a dictionary of {[key: string]: T} to an array [{key: string, ...T]}]
 */
export function convertObjectToArray<
  T extends Record<string, object>,
  R extends { key: string } & T[keyof T]
>(object: T): R[] {
  return Object.entries(object).map(([key, value]) => ({ key, ...value }) as R);
}
